import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseBadgeElement } from '../common';
var PriorityElement = function PriorityElement(props) {
  var _context$priority;
  var context = useFlexibleUiContext();
  var data = (_context$priority = context === null || context === void 0 ? void 0 : context.priority) !== null && _context$priority !== void 0 ? _context$priority : null;
  return data ? /*#__PURE__*/React.createElement(BaseBadgeElement, _extends({}, data, props, {
    name: ElementName.Priority
  })) : null;
};
export default PriorityElement;